import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/years`;
export const allYears = async()=> {
    try {
        const response = await api.get(API_URL);
        return response.data;
        } catch (error) {

        handleHttpError(error, "Erreur lors de la récupération des années.")
        console.error('Error fetching years:', error);
        return [];
    }
}

export const addYears = async (year) => {
    try {
        const response = await api.post(API_URL, year);
        return response.data;
    } catch (error) {
        // Gérer une éventuelle erreur HTTP
        handleHttpError(error, "Erreur lors de l'ajout de l'année.");
        console.error("Error adding year:", error);
        throw error;
    }
};

